import { makeStyles } from "@material-ui/core";

export default function useStyles() {
    return makeStyles((theme) => ({
        root: {
            padding: 20,
        },
        view_card_right: {
            textAlign: "center",
        },
        lb_msg: {
            marginBottom: 0,
        },
        lb_button: {
            margin: 5,
            minWidth: "50%",
            width: "80%",
        },
    }));
}
